export const MODULE_THEMES = {
  couples_counseling: {
    primary: "#E27D60",
    bg: "#FCEEEA",
    icon: "Heart",
    image:
      "https://images.unsplash.com/photo-1494386346843-e12284507169?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  anger_management: {
    primary: "#85B09A",
    bg: "#EDF4F1",
    icon: "Flame",
    image:
      "https://images.unsplash.com/photo-1758799819958-6bfece84708a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  anxiety: {
    primary: "#7B9EBF",
    bg: "#EAF0F6",
    icon: "Wind",
    image:
      "https://images.unsplash.com/photo-1621519997950-158b631341b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  depression: {
    primary: "#E8A87C",
    bg: "#FCF3EB",
    icon: "Sunrise",
    image:
      "https://images.unsplash.com/photo-1621519997950-158b631341b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  bipolar: {
    primary: "#9D8BB6",
    bg: "#F0EDF5",
    icon: "Scale",
    image:
      "https://images.unsplash.com/photo-1758799819958-6bfece84708a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  adhd: {
    primary: "#5BA8A0",
    bg: "#E9F4F3",
    icon: "Target",
    image:
      "https://images.unsplash.com/photo-1494386346843-e12284507169?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  autism_spectrum: {
    primary: "#4E9DC9",
    bg: "#E8F2F8",
    icon: "Puzzle",
    image:
      "https://images.unsplash.com/photo-1621519997950-158b631341b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  ptsd: {
    primary: "#7E8CB5",
    bg: "#EDEFF7",
    icon: "Shield",
    image:
      "https://images.unsplash.com/photo-1758799819958-6bfece84708a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  ocd: {
    primary: "#52A39B",
    bg: "#E7F3F1",
    icon: "Repeat",
    image:
      "https://images.unsplash.com/photo-1621519997950-158b631341b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  substance_recovery: {
    primary: "#6FAE7E",
    bg: "#ECF5EE",
    icon: "Sprout",
    image:
      "https://images.unsplash.com/photo-1494386346843-e12284507169?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  schizophrenia: {
    primary: "#7D93B0",
    bg: "#ECF0F5",
    icon: "Compass",
    image:
      "https://images.unsplash.com/photo-1758799819958-6bfece84708a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  borderline_pd: {
    primary: "#D98BA0",
    bg: "#FBEEF2",
    icon: "Waves",
    image:
      "https://images.unsplash.com/photo-1494386346843-e12284507169?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  narcissistic_pd: {
    primary: "#C9A24B",
    bg: "#F8F1E1",
    icon: "UserCog",
    image:
      "https://images.unsplash.com/photo-1758799819958-6bfece84708a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  grief: {
    primary: "#9A94A8",
    bg: "#F1EFF3",
    icon: "Feather",
    image:
      "https://images.unsplash.com/photo-1621519997950-158b631341b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  self_esteem: {
    primary: "#E0A458",
    bg: "#FBF2E4",
    icon: "Star",
    image:
      "https://images.unsplash.com/photo-1494386346843-e12284507169?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  abandonment: {
    primary: "#6E9EC9",
    bg: "#EAF1F8",
    icon: "Anchor",
    image:
      "https://images.unsplash.com/photo-1758799819958-6bfece84708a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  eating_disorder: {
    primary: "#7FB598",
    bg: "#ECF5EF",
    icon: "Apple",
    image:
      "https://images.unsplash.com/photo-1621519997950-158b631341b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  people_pleasing: {
    primary: "#C58BB0",
    bg: "#F7EDF3",
    icon: "Handshake",
    image:
      "https://images.unsplash.com/photo-1494386346843-e12284507169?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  sex_addiction: {
    primary: "#B0728C",
    bg: "#F6EBF0",
    icon: "HeartHandshake",
    image:
      "https://images.unsplash.com/photo-1758799819958-6bfece84708a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  active_listening: {
    primary: "#5C9EAD",
    bg: "#E8F1F3",
    icon: "Ear",
    image:
      "https://images.unsplash.com/photo-1621519997950-158b631341b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  assertive_communication: {
    primary: "#C98A5B",
    bg: "#F7EEE4",
    icon: "Megaphone",
    image:
      "https://images.unsplash.com/photo-1494386346843-e12284507169?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  conflict_resolution: {
    primary: "#6BA583",
    bg: "#EAF3EE",
    icon: "MessagesSquare",
    image:
      "https://images.unsplash.com/photo-1758799819958-6bfece84708a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  crisis_prevention: {
    primary: "#5B7DB1",
    bg: "#EAEFF7",
    icon: "LifeBuoy",
    image:
      "https://images.unsplash.com/photo-1621519997950-158b631341b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
};

export const GAMI = {
  gold: "#D4AF37",
  fire: "#FF7B54",
  green: "#48BB78",
};

// Canonical program metadata (single source of truth for public + marketing surfaces).
// Names/descriptions mirror the backend MODULES; visual identity is pulled from
// MODULE_THEMES above so color/icon are never duplicated.
const MODULE_META = {
  couples_counseling: { name: "Couples & Marriage Counseling", description: "Build warmth, trust and connection" },
  anger_management: { name: "Anger Management", description: "Cool down, ground yourself, respond with intention" },
  anxiety: { name: "Anxiety", description: "Breathe, create space, find calm" },
  depression: { name: "Depression", description: "Small steps toward hope and light" },
  bipolar: { name: "Bipolar Support", description: "Balance, awareness and steady rhythms" },
  adhd: { name: "ADHD Focus", description: "Clarity, structure and gentle focus" },
  autism_spectrum: { name: "Autism Spectrum", description: "Understanding, sensory calm and self-advocacy" },
  ptsd: { name: "PTSD & Trauma", description: "Grounding, safety and gentle healing" },
  ocd: { name: "OCD", description: "Loosening the grip of obsessions and compulsions" },
  substance_recovery: { name: "Substance Recovery", description: "One day at a time, with support and strength" },
  schizophrenia: { name: "Schizophrenia Support", description: "Stability, routine and staying connected" },
  borderline_pd: { name: "Borderline Personality", description: "Emotional balance with DBT-inspired skills" },
  narcissistic_pd: { name: "Narcissistic Traits", description: "Self-awareness, empathy and connection" },
  grief: { name: "Grief & Loss", description: "Honoring loss and finding your way through" },
  self_esteem: { name: "Self-Esteem", description: "Building steady, kind self-worth from the inside out" },
  abandonment: { name: "Abandonment", description: "Healing the fear of being left and building secure connection" },
  eating_disorder: { name: "Eating Disorder Support", description: "A gentler, kinder relationship with food and body" },
  people_pleasing: { name: "People-Pleasing", description: "Setting boundaries and honoring your own needs" },
  sex_addiction: { name: "Sex & Porn Addiction", description: "Understanding urges, rebuilding intimacy and healthy control" },
  active_listening: { name: "Active Listening & Empathy", description: "Truly hear others and respond with understanding" },
  assertive_communication: { name: "Assertive Communication & Boundaries", description: "Speak your needs clearly, kindly and confidently" },
  conflict_resolution: { name: "Conflict Resolution & Repair", description: "Work through disagreements and repair connection" },
  crisis_prevention: { name: "Suicide & Homicide Prevention", description: "Recognize warning signs, make a safety plan, get help fast" },
};

export const MODULES = Object.keys(MODULE_META).map((key) => ({
  key,
  name: MODULE_META[key].name,
  description: MODULE_META[key].description,
  icon: MODULE_THEMES[key].icon,
  color: MODULE_THEMES[key].primary,
  bg: MODULE_THEMES[key].bg,
}));
